import { createContext } from "react";

export interface IFocusContext {
  isCurrentFocus: boolean;
  isHelpMenuEnabled: boolean;
}

export const FocusContext = createContext<IFocusContext | undefined>(undefined);
